import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import AddOrderNumberDetails from "./AddOrderNumberDetails";
import UpdateGovtOrderNumber from "./UpdateGovtOrderNumber";
import { sweetAlert } from "../../Common/Utills/Utills";

const ViewOrderDetails = () => {
  const [orderDetails, setOrderDetails] = useState([]);
  const params = useParams();
  const formRef = useRef(null);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [filterCriteria, setfilterCriteria] = useState({
    govt_order_details_id: "",
  });
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(-1);
  };

  const getSingleData = async () => {
    const order_id = params.order_id;
    let BASE_URL =
      SERVER_URL +
      `/api/govt-order/single-govt-order-details/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setOrderDetails(result.data);
    } else {
      setOrderDetails([]);
    }
  };
  let check = true;
  useEffect(() => {
    if (check) {
      getSingleData();
    }
    check = false;
  }, [params]);
  useEffect(() => {
    setfilterCriteria({
      govt_order_details_id: orderDetails?.id,
    });
  }, [orderDetails]);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    // gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    // gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const getData = async () => {
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    let BASE_URL =
      SERVER_URL + `/api/govt-order/all-govt-order-number/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      // setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };
  const deleteOrderNumberData = async (order_id) => {
    const message = "Do you want to delete this govt order number!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/govt-order/govt-order-number/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    if (filterCriteria.govt_order_details_id) {
      getData();
    }
  }, [filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View RCA Order Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleNavigate}
              >
                <i
                  className="mdi mdi-arrow-left"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
                Back{" "}
              </button>
            </span>
          </div>
          <div className="form-container">
            <form className="form-sample">
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="alloted_qty">Alloted Quantity</label>
                    <input
                      type="text"
                      className="form-control"
                      name="alloted_qty"
                      id="alloted_qty"
                      value={orderDetails?.alloted_qty}
                      readOnly
                      placeholder="Alloted Quantity"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="circle">Circle</label>
                    <input
                      type="text"
                      className="form-control"
                      name="o_m_circle"
                      id="circle"
                      placeholder="Circle"
                      value={orderDetails?.circle}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="product_name">Size</label>
                    <input
                      type="text"
                      className="form-control"
                      name="product_name"
                      id="product_name"
                      placeholder="Product Name"
                      value={orderDetails?.product_name}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="rate">Rate</label>
                    <input
                      type="text"
                      className="form-control"
                      name="rate"
                      id="rate"
                      placeholder="Rate"
                      value={orderDetails?.rate}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="gst_percent">GST %</label>
                    <input
                      type="text"
                      className="form-control"
                      name="gst_percent"
                      id="gst_percent"
                      placeholder="GST Percent"
                      value={orderDetails?.gst_percent}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="card mt-2">
        <div className="private-table-container">
          <div className="card-body">
            <div className="table_btn">
              <div className="mb-3">
                <button
                  data-toggle="modal"
                  data-target="#exampleModal"
                  className="btn btn-outline-primary"
                >
                  <span className="mr-1">
                    <i className="mdi mdi-briefcase-upload" />
                  </span>
                  Add Order Number Details
                </button>
              </div>

              <div
                style={{
                  marginBottom: "20px",
                }}
              ></div>
            </div>
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Order Number</th>
                    <th>Date</th>
                    <th>Last Date Of Order</th>
                    {/* <th style={{ textAlign: "center" }}>Order Details</th> */}
                    <th>Order Quantity</th>
                    <th>RCA Balance</th>
                    <th>Order Value</th>
                    <th>Order Value (GST Inclusive)</th>
                    <th>Status</th>
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData?.length > 0 ? (
                    rowData &&
                    rowData?.length > 0 &&
                    rowData?.map((item, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          {/* <td style={{ padding: "10px" }}>{index + 1}</td> */}
                          <td style={{ padding: "10px" }}>
                            {(currentPage - 1) * pageSize + index + 1}
                          </td>
                          <td>{item.order_number}</td>
                          <td>{item.date}</td>
                          <td>{item.last_date_offer}</td>
                          {/* <td style={{ padding: "0px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              {item.order_details.map(
                                (orderDetail, orderIndex) => (
                                  <tr key={orderIndex}>
                                    <td>{orderDetail.yard_name}</td>
                                    <td>{orderDetail.company_name}</td>
                                    <td>{orderDetail.order_qty}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </td> */}
                          <td>{item.total_order_qty}</td>
                          <td>{item.rca_balance}</td>
                          <td>{item?.cost}</td>
                          <td>{item?.cost_with_gst}</td>
                          <td>{item.status ? item.status : "-"}</td>
                          <td
                            style={{
                              padding: "10px",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            <span>
                              <button
                                className="btn btn-outline-secondary btn-sm ml-2"
                                onClick={() => addDataToModal(item.id)}
                                data-toggle="modal"
                                data-target="#update"
                              >
                                <i className="mdi mdi-note-edit-outline" />
                              </button>{" "}
                              <button
                                className="btn btn-outline-danger btn-sm ml-2"
                                onClick={() => deleteOrderNumberData(item.id)}
                              >
                                <i className="mdi mdi-delete" />
                              </button>
                            </span>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr className="total-row">
                    <td colSpan={4} className="total-cell">
                      Total
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) => total + parseInt(item.total_order_qty),
                        0
                      )}
                    </td>
                    <td>
                      {rowData.length > 0 &&
                        rowData[rowData.length - 1].rca_balance}
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) => total + parseInt(item.cost),
                        0
                      )}
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) => total + parseInt(item.cost_with_gst),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <AddOrderNumberDetails
              formRef={formRef}
              govt_order_details_id={orderDetails.id}
              getData={getData}
            />
            <UpdateGovtOrderNumber
              rowId={rowId}
              setRowId={setRowId}
              getData={getData}
              govt_order_details_id={orderDetails.id}
            />
          </div>
        </div>
        {/* <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        /> */}
      </div>
    </>
  );
};

export default ViewOrderDetails;
